import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.constructor";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
import axios from 'axios';
export default {
  mixins: [popUp],
  props: {
    divisionAllist: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      dialogFormVisible: false,
      codeList: [],
      divisionAllist: [],
      formData: {
        student_id: '',
        status: '',
        password: '',
        account: '',
        name: '',
        phone: '',
        school: '',
        id_card: '',
        division_ids: []
      },
      rules: {
        status: [{
          required: true,
          message: "请选择",
          trigger: "change"
        }]
      }
    };
  },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var datas, id, status, name, phone, school, id_card, divisions;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data) {
                  _this.copyPrimitive();

                  datas = JSON.parse(JSON.stringify(data));
                  console.log("datas==", datas);
                  id = datas.id, status = datas.status, name = datas.name, phone = datas.phone, school = datas.school, id_card = datas.id_card;
                  divisions = (datas.divisions || []).map(Number);
                  _this.formData = {
                    student_id: id,
                    status: status,
                    name: name,
                    phone: phone,
                    school: school,
                    id_card: id_card,
                    division_ids: divisions
                  };

                  _this.copyData();
                }

                _this.dialogFormVisible = true;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    rewriteClearData: function rewriteClearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.clearData(isClear);
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$refs.ruleForm.validate(function (valid) {
                  if (valid) {
                    _this2.formData.appid = process.env.VUE_APP_APPID;
                    var data = JSON.parse(JSON.stringify(_this2.formData));
                    data.division_ids = data.division_ids.length ? data.division_ids.join(",") : '';

                    _this2.$api.updateStudent(data).then(function (res) {
                      if (res.code == 200) {
                        _this2.$message.success(_this2.formData.id ? '修改成功' : '添加成功');

                        _this2.$emit('change');

                        _this2.dialogFormVisible = false;
                      } else {
                        _this2.$message.error(res.msg);
                      }
                    });
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};